import { TitleDescription } from '@anm/components/TitleBlock';
import { commonInputStyles } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const EmailInput = styled.input`
  margin: 0 auto;
  padding: 0 18px;
  min-width: 273px;
  min-height: 50px;
  margin-top: 24px;
  background: #fff;
  font-size: 16px;
  margin-bottom: 3px;
  ${commonInputStyles};
`;

const buttonDisabledStyles = css`
  color: #919eaa;
  background: #fff;
  border-color: #fff;
  pointer-events: none;
`;

const Wrapper = styled.div<{ isValidEmail: boolean; isButton: boolean }>`
  min-width: calc(333px - 40px);
  img {
    width: 105px;
    margin-top: 2px;
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 21px;
    margin: 12px 0 13px !important;
  }
  ${TitleDescription} {
    font-size: 14px;
    max-width: 280px;
    margin: 0 auto !important;
    line-height: 22px !important;
  }
  button {
    min-width: 150px;
    margin-bottom: 10px;
    display: ${({ isButton }) => (isButton ? 'block' : 'none')};
    ${({ isValidEmail }) => !isValidEmail && buttonDisabledStyles};
  }
`;

export default Wrapper;
